import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const ROUNDS = [
  { statement: "pgvector is a PostgreSQL extension for storing and querying vector embeddings.", real: true },
  { statement: "LangChain was founded by OpenAI in 2022 as an internal research tool.", real: false, correction: "LangChain was created by Harrison Chase, not OpenAI." },
  { statement: "FastAPI automatically generates OpenAPI (Swagger) documentation from Python type hints.", real: true },
  { statement: "Neo4j uses a query language called Cypher for traversing graph data.", real: true },
  { statement: "Kafka was originally built by Twitter to process tweet streams at scale.", real: false, correction: "Kafka was built at LinkedIn, not Twitter." },
  { statement: "Docker containers share the host operating system kernel rather than each having their own.", real: true },
  { statement: "AWS Bedrock is exclusive to Claude models and does not support other LLM providers.", real: false, correction: "Bedrock supports Anthropic, Meta, Mistral, Amazon Titan and others." },
  { statement: "Retrieval Augmented Generation (RAG) grounds LLM responses in external knowledge sources to reduce hallucinations.", real: true },
];

export default function RagOrHallucination({ onDone }) {
  const [idx, setIdx]       = useState(0);
  const [score, setScore]   = useState(0);
  const [picked, setPicked] = useState(null);

  const round = ROUNDS[idx];

  const answer = (isReal) => {
    if (picked !== null) return;
    const correct = isReal === round.real;
    setPicked({ isReal, correct });
    if (correct) setScore(s => s + 1);
  };

  const next = () => {
    if (idx + 1 >= ROUNDS.length) { onDone(score); return; }
    setIdx(i => i + 1);
    setPicked(null);
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 24, color: "var(--text-muted)", fontSize: "0.8rem" }}>
        <span>Round {idx + 1} / {ROUNDS.length}</span>
        <span>Score: {score}</span>
      </div>

      <AnimatePresence mode="wait">
        <motion.div key={idx}
          initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -12 }}
          transition={{ duration: 0.22 }}
        >
          <div style={{ background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 16, padding: "24px", marginBottom: 24, lineHeight: 1.7, fontSize: "0.95rem", color: "var(--text)" }}>
            "{round.statement}"
          </div>

          {picked === null ? (
            <div style={{ display: "flex", gap: 12 }}>
              <button onClick={() => answer(true)} className="btn-pill" style={{ flex: 1, justifyContent: "center" }}>Real</button>
              <button onClick={() => answer(false)} className="btn-pill-outline" style={{ flex: 1, justifyContent: "center" }}>Hallucination</button>
            </div>
          ) : (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <div style={{
                padding: "16px 20px", borderRadius: 12, marginBottom: 16,
                background: picked.correct ? "rgba(34,197,94,0.1)" : "rgba(239,68,68,0.1)",
                border: `1px solid ${picked.correct ? "rgba(34,197,94,0.3)" : "rgba(239,68,68,0.3)"}`,
                color: "var(--text)", fontSize: "0.875rem",
              }}>
                {picked.correct ? "Correct." : `Incorrect — this is ${round.real ? "real" : "a hallucination"}.`}
                {!picked.correct && round.correction && <div style={{ marginTop: 6, color: "var(--text-muted)" }}>{round.correction}</div>}
              </div>
              <button className="btn-pill" onClick={next} style={{ width: "100%", justifyContent: "center" }}>
                {idx + 1 >= ROUNDS.length ? "See Results" : "Next →"}
              </button>
            </motion.div>
          )}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
